import React from 'react';

import { useHooks } from './useHooks';
import { ButtonGroupFulfillmentPicker } from './ButtonGroupFulfillmentPicker';

export const FulfillmentPicker = () => {
  const fulfillmentPickerProps = useHooks();

  return <ButtonGroupFulfillmentPicker {...fulfillmentPickerProps} />;
};
